import CssBaseline from "@material-ui/core/CssBaseline";
import { MuiThemeProvider } from "@material-ui/core/styles";
import React from "react";
import Helmet from "react-helmet";
import theme from "../../components/theme";

interface IProps {
  children: any;
  config: any;
}

const Layout: React.FC<IProps> = (props) => {
  const { title, description, keywords, icon, background } = props.config;
  return (
    <MuiThemeProvider theme={theme}>
      <Helmet>
        <html lang="en" />
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Michael A Zager" />
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        <link rel="stylesheet" type="text/css" href="/css/sprite.css" />
        {/* <link rel="apple-touch-icon" sizes="57x57" href="/icon/apple-icon-57x57.png" />
        <link rel="apple-touch-icon" sizes="60x60" href="/icon/apple-icon-60x60.png" />
        <link rel="apple-touch-icon" sizes="72x72" href="/icon/apple-icon-72x72.png" />
        <link rel="apple-touch-icon" sizes="76x76" href="/icon/apple-icon-76x76.png" />
        <link rel="apple-touch-icon" sizes="114x114" href="/icon/apple-icon-114x114.png" />
        <link rel="apple-touch-icon" sizes="120x120" href="/icon/apple-icon-120x120.png" />
        <link rel="apple-touch-icon" sizes="144x144" href="/icon/apple-icon-144x144.png" />
        <link rel="apple-touch-icon" sizes="152x152" href="/icon/apple-icon-152x152.png" />
        <link rel="apple-touch-icon" sizes="180x180" href="/icon/apple-icon-180x180.png" />
        <link rel="icon" type="image/png" sizes="192x192" href="/icon/android-icon-192x192.png" />
        <link rel="icon" type="image/png" sizes="32x32" href="/icon/favicon-32x32.png" />
        <link rel="icon" type="image/png" sizes="96x96" href="/icon/favicon-96x96.png" />
        <link rel="icon" type="image/png" sizes="16x16" href="/icon/favicon-16x16.png" /> */}
        <link rel="shortcut icon" href={icon} />
        <meta name="msapplication-TileColor" content="/icon/#ffffff" />
        <meta
          name="msapplication-TileImage"
          content="/icon/ms-icon-144x144.png"
        />
        <meta name="author" content="Michael A Zager" />
        <meta name="theme-color" content="#ffffff" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content={title} />
        <meta property="og:site_name" content="Single Cell Atlas" />
        <meta property="og:url" content="https://viz.fredhutch.org/" />
        <meta
          property="og:image"
          content="https://viz.fredhutch.org/img/og-image.jpg"
        />
        <meta property="article:published_time" content="2020-01-01" />
        <meta property="article:author" content="https://viz.fredhutch.org" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@FHDataViz" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
      </Helmet>

      <CssBaseline />
      <div
        style={{
          backgroundImage: `url(${background})`,
          backgroundPosition: "center top",
          backgroundSize: "100% auto",
        }}
      >
        {props.children}
      </div>
    </MuiThemeProvider>
  );
};
import("webfontloader").then((WebFontLoader) => {
  try {
    if (sessionStorage.getItem("fonts")) {
      document.documentElement.classList.add("wf-active");
    }
    WebFontLoader.load({
      google: {
        families: [
          "Material+Icons",
          "Montserrat:400,600",
          "Montserrat+Alternates:400",
        ],
      },
      active: () => {
        sessionStorage.setItem("fonts", "true");
      },
    });
  } catch (e) {
    console.log(e);
  }
});

export default Layout;
